/* eslint-disable */
import { InputAdornment, TextField } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import LabelIcon from '@material-ui/icons/Label';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';
import withServices from '../../Contexts/Services/WithServices.context';
import docketsActionCreators from '../../State/Store/Dockets/Dockets.actions';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import getFiltersSelectedAccount from '../../State/Store/Filters/Selectors/FiltersSelectedAccount.selector';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_PURCHASE_ORDER_SELECTOR_CHANGE } from '../../State/Store/UI/UI.types';
import userProfileSelector from '../../State/Store/UserProfile/Selectors/UserProfileCurrent.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * PurchaseOrderSelector
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const PurchaseOrderSelector = ({ actions, classes, onChange, defaultPurchaseOrder, isRequired, disabled, classEditable, classTouched }) => {
  const [purchaseOrder, setPurchaseOrder] = useState(
    defaultPurchaseOrder && defaultPurchaseOrder.selectedPurchaseOrder ? defaultPurchaseOrder.selectedPurchaseOrder : ``,
  );
  const [isTouched, setIsTouched] = useState(false);

  const fieldClass =
    classTouched && classEditable
      ? isTouched && defaultPurchaseOrder?.selectedPurchaseOrder !== purchaseOrder
        ? classTouched // yellow AFTER change
        : classEditable // green BEFORE change
      : '';

  /**
   * Sets order status and informs parent about changes
   * @param {Object} e event
   * @returns {void} void
   */
  const onPurchaseOrderHandle = (e) => {

    const newValue = e.target.value;
    setPurchaseOrder(newValue);
    // Mark as touched if changed, or reset if it matches original
    const hasChanged = newValue !== (defaultPurchaseOrder?.selectedPurchaseOrder || '');
    setIsTouched(hasChanged);

    let isValid = false;
    if ((e.target.value.trim().length > 0 && e.target.value.trim().length <= 24) || (e.target.value.trim().length === 0 && !isRequired)) {
      isValid = true;
    }
    onChange({ isValid, selectedPurchaseOrder: e.target.value });
    return;
  };

  /**
   * Reports analytics and marks field as touched
   * @param {Object} e event
   * @returns {void} void
   */
  const onBlurHandle = (e) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `orderPurchaseOrderSelector`,
        },
      },
      type: UI_PURCHASE_ORDER_SELECTOR_CHANGE,
    });
    setIsTouched(true);
    return;
  };

  useEffect(() => {
    const isValid = (purchaseOrder.trim().length && purchaseOrder.trim().length <= 24) || !isRequired;
    onChange({ isValid, selectedPurchaseOrder: purchaseOrder });
  }, [isRequired]);

  let helperText = null;
  if (!disabled) {
    helperText = isRequired
      ? `Add your PO number. Max 24 characters. This is required by your Account or Project.`
      : `Optional - Add your own PO number. Max 24 characters.`;
  }

  return (
    <TextField
      className={fieldClass}
      disabled={disabled}
      InputProps={{
        startAdornment: (
          <InputAdornment className={classes.itemIcon}>
            <LabelIcon />
          </InputAdornment>
        ),
      }}
      fullWidth
      error={(!purchaseOrder.trim().length && isRequired) || purchaseOrder.trim().length > 24}
      onChange={onPurchaseOrderHandle}
      onBlur={onBlurHandle}
      value={purchaseOrder}
      label="Purchase Order Number"
      helperText={helperText}
    />
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
PurchaseOrderSelector.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultPurchaseOrder: PropTypes.object,
  isRequired: PropTypes.bool,
  disabled: PropTypes.bool,
  classTouched: PropTypes.string,
  classEditable: PropTypes.string,
};

export default compose(
  withWidth(),
  withRouter,
  withServices,
  connect(
    (state) => ({
      listSettings: state.dockets ? state.dockets.listSettings : null,
      userInfo: userProfileSelector(state),
      currentDateTimeGlobal: getFiltersSelectedAccount(state),
    }),
    (dispatch) => ({
      actions: bindActionCreators(
        {
          ...uiActionCreators,
          ...filtersActionCreators,
          ...docketsActionCreators,
        },
        dispatch,
      ),
    }),
  ),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(PurchaseOrderSelector);
